import React from "react"
import {
    LifecycleEmitter,
    LifecycleEvent,
    trackClickRecipeOnWeekMenu,
    useAutomaticTrackingData,
} from "@ng-mw/shared-react-components"

import "./style/recipe-link.scss"

interface RecipeLinkProps {
    recipeId: string
    recipeName: string
    children?: React.ReactNode[] | React.ReactNode
    id?: string
}

const RecipeLink = ({ recipeId, recipeName, children, id, ...rest }: RecipeLinkProps) => {
    const automaticTrackingData = useAutomaticTrackingData()

    const nativeRecipeClicked = () => {
        trackClickRecipeOnWeekMenu(automaticTrackingData, recipeName, recipeId)

        LifecycleEmitter.broadcast(LifecycleEvent.GoToRecipe, { recipeId })
    }

    return (
        <button
            className="recipe-link"
            onClick={nativeRecipeClicked}
            id={id}
            {...rest}
        >
            {children}
        </button>
    )
}

export default RecipeLink
